import React, { useEffect, useState } from "react";
import axios from "axios";
import { Tab, Header } from "semantic-ui-react";
import { useParams } from "react-router-dom";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import DeDailyEntryDataList from "./DeDailyEntryDataList";

const DeListWithCatogery = () => {
  const [rowData, setrowData] = useState([]);
  const [activeTabIndex, setActiveTabIndex] = useState(0); // Initialize with the desired default tab index (e.g., 0 for visaCategoryId: 0)
  const { catId } = useParams();
  const color = "blue";

  useEffect(() => {
    getWorkCatList();
  }, [catId]); // Add 'id' to the dependency array to re-fetch data when 'id' changes

  const getWorkCatList = () => {
    axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 6598,
      })

      .then((res) => {
        console.log("catogery id", res.data);

        const tempArr = [];

        for (let i = 0; i < res.data.length; i++) {
          tempArr.push({
            visaCategoryId: res.data[i].categoryId,
            visaCategory: res.data[i].categoryName,
          });
        }
        tempArr.push({
          visaCategoryId: 0,
          visaCategory: "All",
        });
        setrowData(tempArr);


      })
      .catch((error) => console.log(error));
  };

  const handleTabChange = (e, { activeIndex }) => {
    console.log("cat id", activeIndex);
    setActiveTabIndex(activeIndex); // Update the active tab index when a tab is clicked
  };

  const panes = rowData.map((item, index) => ({
    menuItem: `${item.visaCategory}`,
    render: () => (
      <Tab.Pane attached={false} key={index}>
        <DeDailyEntryDataList  visaCategoryId={item.visaCategoryId}/>
      </Tab.Pane>
    ),
  }));

  return (
    <div>
      <Header dividing size="huge" as="h1">
        daily  Entry List
      </Header>
      <Tab
        menu={{ color, attached: false, tabular: false, className: "wrapped" }}
        panes={panes}
        activeIndex={activeTabIndex} // Set the active tab index
        onTabChange={handleTabChange} // Handle tab change events
      />
    </div>
  );
};

export default DeListWithCatogery